/** @format */

import * as actionTypes from 'stateContainer/action-types';

const initialState = {
  index: 0,
  infoCenterIndex: 0
};

export const activeNavReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ACTIVE_INDEX:
      return { ...state, index: action.payload };
    case actionTypes.ACTIVE_INDEX_INFO_CENTER:
      return { ...state, infoCenterIndex: action.payload };

    default:
      return state;
  }
};
